import { render, staticRenderFns } from "./ClientesAtendidos.vue?vue&type=template&id=35ef854f&"
import script from "./ClientesAtendidos.vue?vue&type=script&lang=js&"
export * from "./ClientesAtendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports